import React from "react";
import { ArrowRight, BookOpen, Plane, Smartphone, Ticket } from "lucide-react";
import { Link } from "react-router-dom";
import registry from "../../../seo/contentRegistry.generated.json";
import "./home-guides.scss";

const guideIcons = [Smartphone, Plane, Ticket, BookOpen];

export default function HomeGuides() {
  const guides = Object.values(registry.guides).slice(0, 4);

  if (!guides.length) return null;

  return (
    <section className="teleport-section home-guides" aria-labelledby="home-guides-title">
      <div className="home-guides__heading">
        <div>
          <p className="teleport-eyebrow">Travel guides &amp; tips</p>
          <h2 id="home-guides-title">Inspiration for your next adventure</h2>
          <p>Practical travel guidance for smoother journeys.</p>
        </div>
        <Link className="teleport-secondary-button" to="/guides">
          View all articles <ArrowRight size={17} />
        </Link>
      </div>

      <div className="home-guides__grid">
        {guides.map((guide, index) => {
          const Icon = guideIcons[index % guideIcons.length];
          return (
            <Link className="home-guide-card" to={guide.path} key={guide.path}>
              <span className="home-guide-card__icon" aria-hidden="true"><Icon /></span>
              <p>Travel guide</p>
              <h3>{guide.heading}</h3>
              <span>Read guide <ArrowRight size={16} /></span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
